export default __webpack_public_path__ + "static/media/HondaCarLogo.999054e0.png";